import React from "react";
import { Link } from "react-router-dom";
import defaultAvatar from "../images/defaultAvatar.png";
import { getUserImageUrl } from "../constants/config";
import { unwrapUser } from "../utilities/adminAccess";
import { FiLogOut, FiUser } from "react-icons/fi";
import LanguageSwitch from './LanguageSwitch';
import { useI18n } from "../utilities/i18n";

function DropdownMenu(props) {
  const { t } = useI18n();

  const renderUserImage = () => {
    const user = unwrapUser(props.userData);
    const image = user?.image || props.userData?.image || props.userData?.data?.image || '';
    const url = getUserImageUrl(image);
    const rev = props.userData?.image_rev || user?.image_rev;
    const src = url && rev
      ? `${url}${url.includes('?') ? '&' : '?'}v=${rev}`
      : url;
    return (
      <img
        src={src || defaultAvatar}
        className="dropdownAvatar"
        alt=""
        onError={(event) => { event.currentTarget.src = defaultAvatar; }}
      />
    );
  }

  if(props.visible){
    return (
      <div className="dropDownMenu">
        <div className="dropDownUserOverlay">
          <div className="dropDownUserWrapper">
            <div className="dropDownUserConatiner">
            {renderUserImage()}
            <div className="dropDownUserName">{props.userData.name} {props.userData.family}</div>
            </div>
          </div>
        </div>
        <div className="dropDownButtonOverlay">
          <LanguageSwitch variant="menu" />
          {props.onEditAccount ? (
            <Link to="/account" className="dropDownButton" onClick={props.onEditAccount}>
              <FiUser color="#3ad1a0" size="0.9em"/>
              <div className="dropDownButtonText">{t('accEdit')}</div>
            </Link>
          ) : null}
          <div onClick={props.logOut}  className="dropDownButton">
            <FiLogOut color="#3ad1a0" size="0.9em"/>
            <div className="dropDownButtonText">{t('logout')}</div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default DropdownMenu;
